import Vue from 'vue'
import "babel-polyfill"
import Vuex from 'vuex'

Vue.use(Vuex)

const state = {
	adminInfo: {
		user:''
	},
	isRefresh:false,
	navlist:[],
	role:[]
}

const mutations = {
	saveAdminInfo(state, adminInfo){
		state.adminInfo = adminInfo;
	},
	refreshData(state,status){
		state.isRefresh = status
	},
	userNav(state,list){
		state.navlist = list
	},
	userRole(state,list){
		state.role = list
	}
}

export default new Vuex.Store({
	state,
	mutations,
})



// WEBPACK FOOTER //
// ./src/store/index.js